import React, { useState } from 'react';
import { useTranslate } from 'react-redux-multilingual'
// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const LineCustomMadeItem = (props) =>{
    const t = useTranslate();
    const [valueCustomMadeItem,setValueCustomMadeItem]=useState({
        name:'',
        base_price:'',
        price:'',
        // qte:''
    }) 

    // else if(name=='qte'){
    //     let reCalculedPrice = (props.customMadeItem.hasOwnProperty('price') && props.customMadeItem.price!='') ? +props.customMadeItem.price * e.target.value.replace(/[^0-9\.]/g, '') : ''
    //     let reCalculedBase = (props.customMadeItem.hasOwnProperty('base_price') && props.customMadeItem.base_price!='') ? +props.customMadeItem.base_price * e.target.value.replace(/[^0-9\.]/g, '') : ''
    //     setValueCustomMadeItem({...valueCustomMadeItem,[name]:e.target.value.replace(/[^0-9\.]/g, ''),base_price:reCalculedBase,price:reCalculedPrice})
    //     newData.splice(props.indexToEdit,1, {...props.customMadeItem,qte:e.target.value.replace(/[^0-9\.]/g, ''),base_price:reCalculedBase, price:reCalculedPrice})
    // }

    const handleChange = (e,name) =>{
        let newData = [...props.allCustomMadeItem] 

        if(name=='name'){
            setValueCustomMadeItem({...valueCustomMadeItem,[name]:e.target.value})
            newData.splice(props.indexToEdit,1, {...props.customMadeItem,name:e.target.value})
        }else{
            let priceValue = e.target.value.replace(/[^0-9\.]/g, '')
            // let qteMultiple = (props.customMadeItem.hasOwnProperty('qte') && props.customMadeItem.qte!='') ? +props.customMadeItem.qte : 1
            if(name=='base_price'){
                if(props.calculValue.operande!=''){
                    //Ici on calcule le prix final de l'article avec la formule de calcule si une formule à été crée par l'admin
                    let valeurValcul = (props.calculValue.type=='net') ? +props.calculValue.value : +props.calculValue.value * +priceValue/100
                    let calculatedPrice2

                    switch (props.calculValue.operande) {
                        case '*':
                            calculatedPrice2 = +priceValue * +valeurValcul
                        break;
                        case '/':
                            calculatedPrice2 = +priceValue / +valeurValcul
                        break;
                        case '-':
                            calculatedPrice2 = +priceValue - +valeurValcul
                        break;
                        case '+':
                            calculatedPrice2 = +priceValue + +valeurValcul
                        break;
                    } 
                    setValueCustomMadeItem({...valueCustomMadeItem,base_price:priceValue,price:calculatedPrice2})
                    newData.splice(props.indexToEdit,1, {...props.customMadeItem,base_price:priceValue,price:calculatedPrice2})
                }else{
                    setValueCustomMadeItem({...valueCustomMadeItem,base_price:priceValue,price:priceValue})
                    newData.splice(props.indexToEdit,1, {...props.customMadeItem,base_price:priceValue,price:priceValue})
                }
            }else{
                setValueCustomMadeItem({...valueCustomMadeItem,price:priceValue})
                newData.splice(props.indexToEdit,1, {...props.customMadeItem,price:priceValue})
            }
        }
        props.setAllCustomMadeItem(newData)
    }

    const handleDelete = () =>{
        let deletedData = [...props.allCustomMadeItem] 
        deletedData.splice(props.indexToEdit,1)

        props.setAllCustomMadeItem(deletedData)
    }
    
    return (
        <div className={`${(props.indexToEdit%2 == 0) ? 'stripeBg stripePadding px-2 position-relative' : 'stripePadding px-2 position-relative' } mb-3`}>
            <div className="row">
                <div className="col-8">
                    <textarea className='form-control' placeholder='Description' onChange={(e)=>handleChange(e,'name')} rows="2"></textarea>
                </div>
                <div className="col-2">
                    <input value={valueCustomMadeItem.base_price} type="text" placeholder={'Total '+t('supplierPrice').toLowerCase()} className='form-control form-control-sm' onChange={(e)=>handleChange(e,'base_price')} />                    
                </div>
                <div className="col-2">
                    <input value={valueCustomMadeItem.price} type="text" placeholder={'Total '+t('priceTtc').toLowerCase()} className='form-control form-control-sm' onChange={(e)=>handleChange(e,'price')} />
                </div>
            </div>
            {props.deletable &&
                <div className='positionCrossCustomMadeItem' onClick={()=>handleDelete()}>
                    <FontAwesomeIcon icon={faTimesCircle} />
                </div>
            }
        </div>
    )
};

export default LineCustomMadeItem;